import React, { useState } from 'react'
import ButtonLoading from './ButtonLoading'
import { userRequest } from '../utils/requestMethods';

const StatementModal = ({ closeModal, school }) => {
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submitHandler = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await userRequest.post(`/transactions/statement-of-account`, {
                fromDate,
                toDate,
                accountId: school._id,
                accountFor: "school"
            });

            setSuccess("Sent! Your statement is on it's way to your inbox.");
            setTimeout(() => {
                setSuccess("");
                closeModal();
                //setRefresh("information");
                //navigate("/auth/kyc");
            }, 2000);
        } catch (error) {
            console.log(error);
            setError("Something went wrong, try again in a few minutes!");
            setTimeout(() => {
                setError("");
            }, 5000);
        } finally {
            setLoading(false);
        }
    };
return (
    <div>
        <div
        className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-md"
        onClick={closeModal}>
        </div>

        <div id="authentication-modal" tabIndex="-1" aria-hidden="true" className="overflow-y-auto overflow-x-hidden fixed top-3/4 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 w-full md:w-[100%] max-w-md h-[calc(100%-1rem)] max-h-full">
            <div className="relative p-4 w-full max-w-md max-h-full">
                <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                    <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                        <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                            Get Account Statement
                        </h3>
                        <button onClick={closeModal} type="button" className="end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-hide="authentication-modal">
                            <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                            </svg>
                            <span className="sr-only">Close modal</span>
                        </button>
                    </div>
                    <div className="p-4 md:p-5">
                        {error &&
                            <div className="alert alert-warning d-flex align-items-center" role="alert">
                                <i className="fal fa-lock pr-10"></i>
                                <div>{error}</div>
                            </div>
                        }
                        {success &&
                            <div className="alert alert-success d-flex align-items-center" role="alert">
                                <i className="fal fa-lock pr-10"></i>
                                <div>{success}</div>
                            </div>
                        }
                        <form onSubmit={submitHandler} class="space-y-4">
                            <div>
                                <label htmlFor="fromDate" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Start Date</label>
                                <input type="date" id="fromDate" onChange={(e) => setFromDate(e.target.value)} defaultValue={fromDate} className="mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"/>
                            </div>
                            <div>
                                <label htmlFor="toDate" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">End Date</label>
                                <input type="date" id="toDate" onChange={(e) => setToDate(e.target.value)} defaultValue={toDate} className="mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"/>
                            </div>
                            {loading ?
                                (
                                <ButtonLoading styles="w-full text-white bg-blue-500 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center" />
                                ) : (
                                <button type="submit" className="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Generate Statement</button>
                                )
                            }
                        </form>
                    </div>
                </div>
            </div>
        </div> 
    </div>
  )
}

export default StatementModal